import React, { useContext, useCallback } from 'react'
import { ShareLoadContext } from 'apps/fleet-planner/context'
import { Toast } from 'transfix-ui'

export const ShareLoadToastWrapper = () => {
  const { pushNewToastMessage, toastMessage } = useContext(ShareLoadContext)

  const closeHandler = useCallback(() => {
    pushNewToastMessage()
  }, [pushNewToastMessage])

  return (
    <Toast key={toastMessage} message={toastMessage} open={!!toastMessage} onClose={closeHandler} />
  )
}
